import { ReactNode } from 'react';

// material-ui
import { useTheme, useMediaQuery, Divider, List, Typography } from '@mui/material';

// project imports
import { useSelector } from 'store';
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import { GenericCardProps } from 'types';
import { logsEnviroment } from 'config';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

export interface NavGroupProps {
    item: {
        id?: string;
        type?: string;
        icon?: GenericCardProps['iconPrimary'];
        children?: NavGroupProps['item'][];
        title?: ReactNode | string;
        caption?: ReactNode | string;
        color?: 'primary' | 'secondary' | 'default' | undefined;
    };
}

const NavGroup = ({ item }: NavGroupProps) => {
    const theme = useTheme();
    const { drawerOpen } = useSelector((state) => state.menu);
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    // menu list collapse & items
    const items = item.children?.map((menu) => {
        if (menu.id === 'logsPage' && logsEnviroment === null) {
            return null;
        }

        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <>
            <List
                subheader={
                    item.title &&
                    (!matchUpMd || (matchUpMd && drawerOpen)) && (
                        <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
                            {item.title}
                            {item.caption && (
                                <Typography variant="caption" sx={{ ...theme.typography.subMenuCaption }} display="block" gutterBottom>
                                    {item.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {items}
            </List>

            {/* group divider */}
            {(!matchUpMd || (matchUpMd && drawerOpen)) && <Divider sx={{ mt: 0.25, mb: 1.25 }} />}
        </>
    );
};

export default NavGroup;
